import { EntryType } from 'openapi';

import { DocumentsUpload } from 'pages/DocumentsUpload/DocumentsUpload';

import { getInvoiceColumns } from 'utils/helpers/invoiceHelpers';
import { ExpensesProps } from 'utils/interfaces/ActionsEnabled';
import { AppRoutesEnum } from 'utils/routes';

export const Expenses = ({ filterType, isOnAllCompanies }: ExpensesProps) => {
  return (
    <DocumentsUpload
      filterType={filterType}
      isOnAllCompanies={isOnAllCompanies}
      stateRoute={
        isOnAllCompanies
          ? AppRoutesEnum.INVOICES
          : AppRoutesEnum.COMPANY_INVOICES
      }
      getColumns={(translate) =>
        getInvoiceColumns(isOnAllCompanies ?? false, translate)
      }
      entryType={EntryType.EXPENSE}
    />
  );
};
